import { OrigemAssociacaoItensNFeEntradaEnum } from '@shared/enums/suprimentos/origem-associacao-itens-nfe-entrada.enum';
import { RegraCorrespondenciaProdutoNFeEntradaEnum } from '@shared/enums/suprimentos/regra-correspondencia-produto-nfe-entrada.enum';

/** Ordem padrão das quatro regras reordenáveis, usada quando o assistente de importação não informa outra. */
export const ORDEM_REGRAS_CORRESPONDENCIA_PADRAO: RegraCorrespondenciaProdutoNFeEntradaEnum[] = [
  RegraCorrespondenciaProdutoNFeEntradaEnum.Ean,
  RegraCorrespondenciaProdutoNFeEntradaEnum.FornecedorCodigoDescricao,
  RegraCorrespondenciaProdutoNFeEntradaEnum.FornecedorCodigo,
  RegraCorrespondenciaProdutoNFeEntradaEnum.CodigoDescricao,
];

export class NotaFiscalEntradaAssociacaoDialogData {
  idNFeEntrada: number;
  origem: OrigemAssociacaoItensNFeEntradaEnum;
  isSomenteLeitura = false;
  ordemRegras: RegraCorrespondenciaProdutoNFeEntradaEnum[] | null = null;
  considerarApenasDescricao = false;
}

export class NotaFiscalEntradaAssociacaoDialogResult {
  salvo = false;
  /** Associação concluída sem divergência bloqueante: o processo de compras segue para o vínculo com o pedido. */
  confirmado = false;
  /** Associação concluída, mas a nota ficou com divergência bloqueante (o modal já avisou). */
  possuiDivergenciaBloqueante = false;
}
